import { useState } from "react";
import MyTable from "../../Components/MyTable";
import Mytitle from "../../Components/Mytitle";
import ModalForm from "../../Components/ModalForm";
import MyInput from "../../Components/Myinput";
import API from "../../Api/axiosConfig";
import { toast } from "react-toastify";
import MyButton from "../../Components/MyButton";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPen, faTrash } from "@fortawesome/free-solid-svg-icons";
import Can from "../../Components/Can";

function Employees() {
  const [showModal, setShowModal] = useState(false);
  const [formData, setFormData] = useState({
    name: "",
    age: "",
    gender: "",
    national_id: null,
    phone: null,
    address: "",
    salary: "",
    active: true,
  });
  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);
  const [refreshKey, setRefreshKey] = useState(0);
  const [editId, setEditId] = useState(null);

  const [deleteId, setDeleteId] = useState(null);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [deleting, setDeleting] = useState(false);

  const handleAdd = () => {
    setFormData({
      name: "",
      age: "",
      gender: "",
      national_id: null,
      phone: null,
      address: "",
      salary: "",
    });
    setEditId(null);
    setErrors({});
    setShowModal(true);
  };

  const handleEdit = (employee) => {
    setFormData({ ...employee });
    setEditId(employee.uuid);
    setErrors({});
    setShowModal(true);
  };

  const handleDeleteClick = (uuid) => {
    setDeleteId(uuid);
    setShowDeleteModal(true);
  };

  const confirmDelete = async () => {
    setDeleting(true);
    try {
      await API.delete(`/employees/${deleteId}`);
      console.log("تم حذف الموظف بنجاح");
      setRefreshKey((prev) => prev + 1);
      setShowDeleteModal(false);
      setDeleteId(null);
    } catch (err) {
      console.error(err);
      toast.error("فشل الحذف");
    } finally {
      setDeleting(false);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setErrors({});

    try {
      if (editId) {
        await API.put(`/employees/${editId}`, formData);
        console.log("تم تعديل الموظف بنجاح");
      } else {
        await API.post("/employees", formData);
        console.log("تم إضافة الموظف بنجاح");
      }
      setShowModal(false);
      setRefreshKey((prev) => prev + 1);
    } catch (err) {
      if (err.response?.data?.errors) {
        setErrors(err.response.data.errors);
      }
    } finally {
      setLoading(false);
    }
  };

  const columns = [
    { header: "الاسم", accessor: "name" },
    { header: "السن", accessor: "age" },
    {
      header: "النوع",
      accessor: (row) =>
        row.gender === "male" ? "ذكر" : row.gender === "female" ? "أنثي" : "-",
    },
    { header: "رقم الهوية", accessor: "national_id" },
    { header: "الهاتف", accessor: "phone" },
    { header: "العنوان", accessor: "address" },
    { header: "الراتب", accessor: "salary" },
    {
      header: "الحالة",
      accessor: (row) => (row.active ? "نشط" : "غير نشط"),
    },
    {
      header: "الإجراءات",
      accessor: (row) => (
        <>
          <Can permission="employee_update">
            <button
              className="btn btn-sm btn-primary mx-1 no-style"
              onClick={() => handleEdit(row)}>
              <FontAwesomeIcon icon={faPen} />
            </button>
          </Can>
          <Can permission="employee_delete">
            <button
              className="btn btn-sm btn-danger no-style"
              onClick={() => handleDeleteClick(row.uuid)}>
              <FontAwesomeIcon icon={faTrash} />
            </button>
          </Can>
        </>
      ),
      hideOnPrint: true,
    },
  ];

  return (
    <div className="container mt-5">
      <Mytitle title="الموظفون" />
      {/* <Can permission="employee_create">
                <MyButton
                    text="إضافة موظف جديد"
                    variant="success"
                    type="button"
                    className="mb-3"
                    onClick={handleAdd}
                />
            </Can> */}

      <ModalForm
        show={showModal}
        onClose={() => setShowModal(false)}
        title={editId ? "تعديل الموظف" : "إضافة موظف جديد"}
        onSubmit={handleSubmit}
        loading={loading}
        mode="form">
        {editId && (
          <MyInput
            // label="النوع"
            value={formData.active}
            onChange={(e) =>
              setFormData({ ...formData, active: e.target.value })
            }
            error={errors.active?.[0]}
            as="select"
            options={[
              { value: "", label: "اختر الحالة" },
              { value: 1, label: "نشط" },
              { value: 0, label: "غير نشط" },
            ]}
          />
        )}
        <MyInput
          label="الاسم"
          value={formData.name}
          onChange={(e) => setFormData({ ...formData, name: e.target.value })}
          error={errors.name?.[0]}
        />
        <MyInput
          label="السن"
          type="number"
          value={formData.age}
          onChange={(e) => setFormData({ ...formData, age: e.target.value })}
          error={errors.age?.[0]}
        />
        <MyInput
          // label="النوع"
          value={formData.gender}
          onChange={(e) => setFormData({ ...formData, gender: e.target.value })}
          error={errors.gender?.[0]}
          as="select"
          options={[
            { value: "", label: "اختر النوع" },
            { value: "male", label: "ذكر" },
            { value: "female", label: "أنثى" },
          ]}
        />

        <MyInput
          label="رقم الهوية"
          value={formData.national_id}
          onChange={(e) =>
            setFormData({ ...formData, national_id: e.target.value })
          }
          error={errors.national_id?.[0]}
        />
        <MyInput
          label="الهاتف"
          value={formData.phone}
          onChange={(e) => setFormData({ ...formData, phone: e.target.value })}
          error={errors.phone?.[0]}
        />
        <MyInput
          label="العنوان"
          value={formData.address}
          onChange={(e) =>
            setFormData({ ...formData, address: e.target.value })
          }
          error={errors.address?.[0]}
        />
        <MyInput
          label="الراتب"
          type="number"
          value={formData.salary}
          onChange={(e) => setFormData({ ...formData, salary: e.target.value })}
          error={errors.salary?.[0]}
        />
      </ModalForm>

      <ModalForm
        show={showDeleteModal}
        onClose={() => setShowDeleteModal(false)}
        title="تأكيد الحذف"
        onSubmit={confirmDelete}
        loading={deleting}
        mode="confirm"
        confirmText="حذف"
        cancelText="إلغاء">
        هل أنت متأكد أنك تريد حذف هذا الموظف؟
      </ModalForm>

      <MyTable
        resource="employees"
        title={"الموظفين"}
        columns={columns}
        refreshKey={refreshKey}
        filters={[
          { type: "text", name: "name", label: "بحث باسم الموظف" },
          // { type: "text", name: "customer.name", label: "بحث باسم العميل" },
          {
            type: "select",
            name: "active",
            label: "الحالة",
            options: [
              { value: "", label: "الكل" },
              { value: 1, label: "نشط" },
              { value: 0, label: "غير نشط" },
            ],
          },
        ]}
        button={{
          text: "إضافة موظف",
          onClick: handleAdd,
          permission: "employee_create",
        }}
      />
    </div>
  );
}

export default Employees;
